import React, { useEffect } from 'react';
import range from 'lodash/range';
import { Box } from '@/shared/ui/box';
import { Button } from '@/shared/ui/form/button';
import {
  BodyTextRegularSecondary,
  BodyTextBoldSecondary,
} from '@/shared/ui/typography';
import { Timer } from '@/shared/ui/timer';

import { useAuth } from '@/features/auth-managment/model/auth-context';
import { SMSInput } from '@/shared/ui/form/sms-input';

import {
  FormWrapper,
  SpinnerBox,
  CircleBorder,
  CircleCore,
  CircleImage,
  ConfirmationFormWrapper,
  AuthCloseIconImage,
  FormContainer,
} from '@/features/auth-managment/styles';

export const SmsConfirmation = () => {
  const {
    t,
    handleClose,
    currentStep,
    inputRefs,
    handleResetPassword,
    handleDigitChange,
    handleKeyDown,
    digits,
    handleSmsSubmit,
    setDigits,
  } = useAuth();

  useEffect(() => {
    setDigits(Array(6).fill(''));
  }, []);

  return (
    <FormWrapper $currentStep={currentStep}>
      <FormContainer>
        <Box onClick={handleClose}>
          <AuthCloseIconImage
            width={32}
            height={32}
            src="/images/icons/close-dialog.svg"
          />
        </Box>

        <SpinnerBox>
          <CircleBorder>
            <CircleCore />
          </CircleBorder>
          <CircleImage
            width={56}
            height={56}
            src={'/images/background/chat-spin.svg'}
          />
        </SpinnerBox>

        <Box $paddingTop={16} $paddingBottom={16} $textAlign="center">
          <BodyTextRegularSecondary color="#AFAFAF">
            {t('auth.sms.desc')}
          </BodyTextRegularSecondary>
        </Box>

        <BodyTextBoldSecondary>{t('auth.sms.code')}</BodyTextBoldSecondary>
        <ConfirmationFormWrapper>
          {range(6).map((index) => (
            <SMSInput
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              index={index}
              value={digits?.[index]}
              onChange={handleDigitChange}
              onKeyDown={handleKeyDown}
            />
          ))}
        </ConfirmationFormWrapper>
        <Box
          $paddingTop={16}
          $paddingBottom={16}
          $display="flex"
          $justifyContent="center"
          $alignItems="center"
          $gap={8}
        >
          <Box $cursor="pointer" onClick={handleResetPassword}>
            <BodyTextRegularSecondary color="#AFAFAF">
              {t('auth.sms.resend_question')}
            </BodyTextRegularSecondary>
          </Box>

          <Timer
            handleResend={handleSmsSubmit}
            triggerSlot={
              <Button variant="orangeGradient">{t('auth.sms.resend')}</Button>
            }
          />
        </Box>
      </FormContainer>
    </FormWrapper>
  );
};
